import { render, staticRenderFns } from "./AdminConfirmResetPassword.vue?vue&type=template&id=07dad0a2"
import script from "./AdminConfirmResetPassword.vue?vue&type=script&lang=js"
export * from "./AdminConfirmResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports